import React, { useState } from 'react';
import { Spacer } from '@/globalStyles';
import { FacebookIcon, ForgeMarkIcon, InstagramIcon, LinkedinIcon, XIcon } from '@/icons';
import { buildSupportSnapshotText } from '@/utils/supportSnapshot';
import {
  FooterContainer,
  FooterCopyright,
  FooterTextContainer,
  SocialIcon,
  FooterCopyrightSection,
  FooterLinksSection,
  FooterSocialSection,
  SocialLink,
  FooterLink,
  FooterActionButton,
  FooterHintText,
  FooterSoftwareCredit,
  FooterForgeMark,
} from './Footer.elements';

export const Footer = () => {
  const [copyStatus, setCopyStatus] = useState("");

  const copySupportSnapshot = async () => {
    try {
      const snapshotText = buildSupportSnapshotText();
      await navigator.clipboard.writeText(snapshotText);
      setCopyStatus("Support snapshot copied.");
      window.setTimeout(() => setCopyStatus(""), 4000);
    } catch (error) {
      setCopyStatus("Could not copy snapshot. Please try again.");
      window.setTimeout(() => setCopyStatus(""), 4000);
    }
  };

  return (
    <FooterContainer>
      <FooterTextContainer>
        <FooterLinksSection>
          <FooterLink to="/privacy-policy">PRIVACY POLICY</FooterLink>
          {'|'}
          <FooterLink to="/terms-of-use">TERMS OF USE</FooterLink>
          {'|'}
          <FooterActionButton type="button" onClick={copySupportSnapshot}>
            COPY SUPPORT SNAPSHOT
          </FooterActionButton>
        </FooterLinksSection>
        {copyStatus && <FooterHintText role="status">{copyStatus}</FooterHintText>}
        <Spacer />
        <FooterSocialSection>
          <SocialLink href="https://x.com/clippn" target="_blank" aria-label="X"><SocialIcon as={XIcon} /></SocialLink>
          <SocialLink href="https://www.facebook.com/clippn/" target="_blank" aria-label="Facebook"><SocialIcon as={FacebookIcon} /></SocialLink>
          <SocialLink href="https://www.linkedin.com/company/clippn/" target="_blank" aria-label="LinkedIn"><SocialIcon as={LinkedinIcon} /></SocialLink>
          <SocialLink href="https://www.instagram.com/clippn_inc/" target="_blank" aria-label="Instagram"><SocialIcon as={InstagramIcon} /></SocialLink>
        </FooterSocialSection>
        <FooterCopyrightSection>
          <FooterCopyright>
            COPYRIGHT 2026 CLIPPN, INC. ALL RIGHTS RESERVED.
          </FooterCopyright>
          {/* The line above covers the service and the brand. This one covers
              the software itself, which is a separate ownership. */}
          <FooterSoftwareCredit>
            <FooterForgeMark as={ForgeMarkIcon} aria-hidden="true" />
            SOFTWARE CREATED AND OWNED BY FORGESOFT LIMITED. ALL RIGHTS RESERVED.
          </FooterSoftwareCredit>
        </FooterCopyrightSection>
      </FooterTextContainer>
    </FooterContainer>
  );
};
